var exports = {
  "h_": "GiftSendToFriendModal.module__description___S1pnbH",
  "jo": "GiftSendToFriendModal.module__sendButton___S1pnbH",
  "Zw": "GiftSendToFriendModal.module__giftCodeText___S1pnbH",
  "A4": "GiftSendToFriendModal.module__giftCode___S1pnbH",
};

module.exports = exports;
